import React, { useEffect } from "react";
import { observer } from "mobx-react";
import ConnectWhatsAppButton from "./ConnectWhatsAppButton";
import { whatsAppReplyState } from "./state";
import ConnectedWhatsAppList from "./ConnectedWhatsAppList";
import ConnectedWhatsAppConfigure from "./ConnectedWhatsAppConfigure";
import { getFeatureFlagWithTeam } from "Utils/commonAPI";
import userDetail from "Stores/userDetail";
import {
  WA_BC_NAME,
  WA_CONNECTION_SUCCESS_MESSAGE,
  WA_CONNECTION_FAILURE_MESSAGE
} from "./waConnectionMessages";

const WhatsAppAccounts = observer(() => {
  useEffect(() => {
    (async () => {
      // Refresh plan/team limits (incl. WhatsApp slots) before getCurrentTeam patches usage,
      // so we don't show a stale "not on your plan" state from an older session.
      const flags = await getFeatureFlagWithTeam();
      if (flags && Object.keys(flags).length > 0) {
        userDetail.setUserFeatureFlag(flags);
      }
      await whatsAppReplyState.getCurrentTeam();
      whatsAppReplyState.setWaDataLoading(true);
      whatsAppReplyState.getWhatsappAccounts();
    })();
  }, []);

  useEffect(() => {
    const onMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.data === WA_CONNECTION_SUCCESS_MESSAGE) {
        whatsAppReplyState.closeWaAuthPopupFromSuccess();
        whatsAppReplyState.getWhatsappAccounts();
      } else if (event.data === WA_CONNECTION_FAILURE_MESSAGE) {
        whatsAppReplyState.closeWaAuthPopupFromSuccess();
      }
    };
    window.addEventListener("message", onMessage);

    let bc;
    if (typeof BroadcastChannel !== "undefined") {
      bc = new BroadcastChannel(WA_BC_NAME);
      bc.onmessage = (ev) => {
        if (ev.data === WA_CONNECTION_SUCCESS_MESSAGE) {
          whatsAppReplyState.closeWaAuthPopupFromSuccess();
          whatsAppReplyState.getWhatsappAccounts();
        } else if (ev.data === WA_CONNECTION_FAILURE_MESSAGE) {
          whatsAppReplyState.closeWaAuthPopupFromSuccess();
        }
      };
    }

    return () => {
      window.removeEventListener("message", onMessage);
      if (bc) bc.close();
    };
  }, []);

  return (
    <div
      className={`connectLinkedInBody ${
        whatsAppReplyState?.waConnected ? "linkedInAccountConnected" : ""
      }`}
    >
      {whatsAppReplyState?.waConnected ? (
        whatsAppReplyState?.showConfigure ? (
          <ConnectedWhatsAppConfigure />
        ) : (
          <div className="connectedLinkedInAccountsBody">
            <ConnectedWhatsAppList />
          </div>
        )
      ) : (
        <ConnectWhatsAppButton />
      )}
    </div>
  );
});

export { WhatsAppAccounts };
export default WhatsAppAccounts;
